// The SMART SIDEBAR beside a link opened from the chat (busy-my-web#397, part b — the seam).
//
// Saffet: "If you open it with a google web browser then a new page outside of Busy.me opens and
// our smart sidebar will appear next to it on the right ready to save whatever you like videos,
// text photos video the journey like scribe create tasks, notes, events, contacts."
//
// A panel that stands NEXT TO a page in another browser tab is a browser extension's, not this
// app's — a web page cannot reach into a tab it did not open, let alone read what is on it. What
// this app CAN do the moment a link leaves it is put the link's own briefing on its right-hand rail:
// what the page is, which question it answered, and the four things the reader may want to make
// from it. That rail is the seam the extension later feeds (page text, selection, media); until
// then it works from what the chat already knows about the link.
//
// Pure on purpose: the model the panel draws and the create-form payload it sends, with no store
// and no DOM, so both are testable without mounting anything.

/** The kinds of entity the sidebar offers to create from the page — the SmartBox's own menus. */
export const CREATE_MENUS = Object.freeze([
  { menu: 'tasks', label: 'Task' },
  { menu: 'notes', label: 'Note' },
  { menu: 'events', label: 'Event' },
  { menu: 'contacts', label: 'Contact' },
])

/** The host of a URL, without its `www.` — the same reading every card's host line uses. */
export function hostOf(url) {
  try { return new URL(String(url)).hostname.replace(/^www\./, '') } catch { return '' }
}

/**
 * What the panel draws for an opened link: `null` when there is no link (the rail is not ours).
 *
 * @param {{ url, title?, snippet?, thumbnail?, kind? }} link the link as the chat holds it
 * @param {string} question the turn's question — the reason this page was suggested
 */
export function linkSidebarModel(link, question = '') {
  const url = String(link?.url || '').trim()
  if (!url) return null
  const host = hostOf(url)
  const title = String(link?.title || '').trim()
  return {
    url,
    host,
    // A link whose title is its own address has no title worth printing twice.
    title: title && title !== url ? title : host || url,
    snippet: String(link?.snippet || '').trim(),
    thumbnail: String(link?.thumbnail || '').trim(),
    video: link?.kind === 'video',
    question: String(question || '').trim(),
  }
}

/**
 * The SmartBox opener for "create a <menu> from this page" — the same `smartbox-edit-entity` detail
 * the Work-board sends for a research snippet (Workboard.vue): a menu and a title with no id behind
 * it opens the box as a WRITABLE draft, prefilled. The page's address rides in the body so the
 * created thing keeps its provenance; the snippet follows it when there is one.
 *
 * @returns {object|null} null for a menu the box does not open, or no link
 */
export function createDetail(menu, model) {
  if (!model?.url || !CREATE_MENUS.some(m => m.menu === menu)) return null
  const body = [model.url, model.snippet].filter(Boolean).join('\n\n')
  return {
    menu,
    title: model.title,
    content: body,
    origin: 'link-sidebar',
  }
}
